export const ConsumerSubmitConsentStyles = {
  header: 'text-coolGray900 text-16px mb-2 font-black',
  checkboxContainer: 'mb-10',
  label: 'font-normal text-10px text-gray150 tracking-wide ml-1 leading-normal',
  consentLink: `inline-block mt-2`,
}
